import { render } from "./PolicyProtocolPage.vue?vue&type=template&id=9244bb26&scoped=true"
import script from "./PolicyProtocolPage.vue?vue&type=script&lang=js"
export * from "./PolicyProtocolPage.vue?vue&type=script&lang=js"

import "../child/policyChildDoc.css?vue&type=style&index=0&lang=css"
import "./PolicyProtocolPage.vue?vue&type=style&index=1&id=9244bb26&scoped=true&lang=css"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9244bb26"]])

export default __exports__